export class AccountMovementDataEntity {
  constructor(
    public accountType: string,
    public accountName: string,
    public accountNumber: string,
    public balance: number
  ) {}
}
